"use client"

import { useEffect, useState } from "react"

type ThemeMode = "auto" | "light" | "dark"

const getAutoTheme = () => {
  const hour = new Date().getHours()
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches
  return prefersDark || hour < 7 || hour >= 20 ? "dark" : "light"
}

const applyTheme = (mode: ThemeMode) => {
  const theme = mode === "auto" ? getAutoTheme() : mode
  document.documentElement.classList.toggle("dark", theme === "dark")
  document.documentElement.dataset.theme = theme
  document.documentElement.dataset.mode = mode
}

export default function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>("auto")

  useEffect(() => {
    const saved = localStorage.getItem("kvatronix-theme") as ThemeMode | null
    const next = saved === "light" || saved === "dark" || saved === "auto" ? saved : "auto"
    setMode(next)
    applyTheme(next)
  }, [])

  const toggle = () => {
    const next: ThemeMode = mode === "auto" ? "dark" : mode === "dark" ? "light" : "auto"
    setMode(next)
    localStorage.setItem("kvatronix-theme", next)
    applyTheme(next)
  }

  return (
    <button
      onClick={toggle}
      className="rounded-full border border-slate-300/40 bg-white/70 px-3 py-2 text-xs font-medium text-slate-700 shadow-sm backdrop-blur transition hover:bg-white dark:border-white/10 dark:bg-white/10 dark:text-white dark:hover:bg-white/15"
      title="Theme mode"
      aria-label="Theme mode"
    >
      {mode === "auto" ? "Auto" : mode === "dark" ? "Dark" : "Light"}
    </button>
  )
}